import React, { useMemo } from 'react';
import SearchableSelect from '../../common/SearchableSelect';
import './SheetInputs.scss';

/**
 * Controlled object-ref dropdown for a sheet cell (stores _id, shows label).
 * Searchable via react-select (same component as DocHub modals).
 */
const SheetRefDropdown = ({
  value = '',
  options = [],
  optionValues = [],
  onChange,
  disabled = false,
  title,
  textAlign = 'left',
  placeholder = ''
}) => {
  const normalizedValue = value === undefined || value === null ? '' : String(value);

  const selectOptions = useMemo(
    () =>
      optionValues.map((optVal, index) => ({
        label: String(options[index] ?? optVal ?? ''),
        value: String(optVal ?? '')
      })),
    [options, optionValues]
  );

  return (
    <div
      className="dochub-sheet-select-wrap"
      title={title}
      style={{ textAlign }}
      onClick={e => e.stopPropagation()}
      onMouseDown={e => e.stopPropagation()}
    >
      <SearchableSelect
        options={selectOptions}
        value={normalizedValue}
        onChange={next => {
          if (onChange) onChange(next);
        }}
        placeholder={placeholder || '—'}
        isClearable
        isDisabled={disabled}
        variant="sheet"
        aria-label={placeholder || title}
      />
    </div>
  );
};

export default SheetRefDropdown;
